<template>
    <div class="bg-white shadow-sm rounded-lg p-4">

        <h2 class="font-weight-400 text-center mt-3">Check Payment</h2>

        <form class="card-body" method="post" @submit.prevent="submit">
            <div class="form-group ">
                <label>Batch Code / Invoice Number / Reference</label>
                <input type="text" v-model="form.code" value=""
                       :class="[ 'form-control' , form.errors.get('code') ? 'is-invalid' : '' ]"
                       placeholder="Batch Code / Invoice Number / Reference">
                <div v-text="form.errors.get('code')" class="invalid-feedback"/>
            </div>
            <button @click.prevent="submit"
                    :class="['btn btn-primary btn-block mt-4' , form.loading ? 'btn-loading' : '']">
                Submit
            </button>
            <div class="text-black-50 mt-2">Want to
                <router-link to="/business/transact">make a payment</router-link>
                instead?
            </div>
        </form>
    </div>
</template>

<script>
import Form from "../../../core/forms/form";
import {storage} from "../../../core/utils/storage";

export default {
    name: "business-check",
    mixins: [storage],

    mounted() {
        this.initStorage(['code']);
    },

    methods: {
        submit: function () {
            this.saveToLocalStorage();
            this.form.upload('/business/check').then((response) => {
                if (response.data.success) {
                    this.$router.push(`/business/view?ref=${response.data.body.ref}`);
                }
            });
        },
    },
    data() {
        return {
            stage: 1,
            form: new Form({
                code: "",
            })
        };
    }
}
</script>
